/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CreditCardLimitFeeResponseViewModel } from "../types/CreditCardLimitFeeResponseViewModel.ts";

export const creditCardLimitFeeResponseViewModelSchema = z.object({
  id: z.string().nullish(),
  name: z.string().nullish(),
  value: z.number().nullish(),
}) as unknown as ToZod<CreditCardLimitFeeResponseViewModel>;
